import { Flex, HttpsOutlinedIcon, Text } from '@shared/components';

export default function RequireAdornment() {
  return (
    <Flex
      sx={(theme) => ({
        color: theme.palette.text.disabled,
        gap: theme.spacing(1),
        alignItems: 'center',
      })}
    >
      <HttpsOutlinedIcon />
      <Text>Required</Text>
    </Flex>
  );
}
